import { type Received } from 'validation';

import { getRecord } from 'api/shared/getRecord';
import { folderSchema, type Folder } from 'redux/slices/lists/foldersSlice';

/**
 * GET `/folders/:id` — one record for the edit dialog, so it works
 * when launched from the Workspace (which never populates the list slice) and
 * never opens on a loosely-cast store row.
 *
 * Boundary-validated. See `getRecord` for what each outcome means; the short
 * version is that `null` means the server said there is no such record, and
 * the failure arm means it said something we could not read. The caller must
 * tell those apart, because refreshing a list helps with only one of them.
 */
export const getFolder = (id: number): Promise<Received<Folder | null>> => getRecord(`/folders/${id}`, { schema: folderSchema, source: 'getFolder' });
